// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"401":"c1fc40b1","496":"1a4e8fdd","618":"914a42f0","787":"657fdec5"}[chunkId] + ".chunk.js";
};